import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            Meet our talented team of experts dedicated to delivering exceptional results.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team team-des">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img team-img-border" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <b><p>{d.job}</p></b>
                      <p dangerouslySetInnerHTML={{ __html: d.description }}></p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
